import styles from './ImageModal.module.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ImageModal = () => {

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.contents}>
                    <img 
                        className={styles.contentImage} 
                        alt="" 
                        src="https://hotple.s3.ap-northeast-2.amazonaws.com/usage/letter_content.png"
                    />
                </div>
            </div>
        </div>
    );
};

export default ImageModal;
